import React, { useState } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import Pagination from "../../pagination/Pagination";

const ResultFragment = ({ examData }) => {
  const itemsPerPage = 5;
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(itemsPerPage);
  const len = examData?.questions?.length;

  return (
    <section className="flex flex-col gap-6">
      <div className="flex flex-row justify-between items-center">
        <h2 className="text-[28px] font-semibold text-textPrimary leading-[40px]">
          Results
        </h2>
        <span className="tracking-wider text-[18px] font-semibold">
          Points: {examData?.points}/{examData?.maxPoints}
        </span>
      </div>
      <section className="flex items-start justify-between gap-3">
        {!examData ? (
          <p>No data found</p>
        ) : (
          <div className="sm:px-8 w-full">
            {examData?.questions
              ?.slice([startIndex], [endIndex])
              .map((question, index) => (
                <div key={index} className="pb-6 w-full">
                  <div className="flex flex-col pb-1">
                    <p className="text-textPrimary font-medium">
                      {index + startIndex + 1}.{" "}
                      {question?.questionData?.questions}
                    </p>
                  </div>
                  <fieldset className="flex flex-col gap-2 pl-6 border border-solid border-gray-300 p-3 w-full">
                    {!question?.submittedAnswer ? (
                      <legend className="text-white bg-red-500 w-max px-2 py-1 rounded-sm">
                        Not answered
                      </legend>
                    ) : question?.isCorrect ? (
                      <legend className="text-white bg-green-600 w-max px-2 py-1 rounded-sm">
                        Correct
                      </legend>
                    ) : (
                      <legend className="text-white bg-red-500 w-max px-2 py-1 rounded-sm">
                        Incorrect
                      </legend>
                    )}
                    {question?.questionData?.optionsOfAnswer?.map((option) => (
                      <div
                        key={option?._id}
                        className="flex flex-row items-center"
                      >
                        <p
                          htmlFor={option?._id}
                          className="text-textSecondary flex gap-2 flex-row items-center"
                        >
                          <span>{option?.option}</span>
                          {option?.isCorrect ? (
                            <>
                              <FaCheck className="text-green-600" />
                              <span className="text-sm text-green-600">
                                Correct Answer
                              </span>
                            </>
                          ) : option?._id === question?.submittedAnswer ? (
                            <>
                              <FaTimes className="text-red-500" />
                              <span className="text-sm text-red-500">
                                Your answer
                              </span>
                            </>
                          ) : null}
                        </p>
                      </div>
                    ))}
                  </fieldset>
                </div>
              ))}
          </div>
        )}
      </section>
      <Pagination
        len={len}
        itemsPerPage={itemsPerPage}
        startIndex={startIndex}
        setStartIndex={setStartIndex}
        setEndIndex={setEndIndex}
        endIndex={endIndex}
      />
    </section>
  );
};

export default ResultFragment;
